import * as tslib_1 from "tslib";
import { Component, Prop, Vue } from "vue-property-decorator";
import LongContentContainer from '@/components/LongContentContainer/index.vue';
let QuestionHeader = class QuestionHeader extends Vue {
};
tslib_1.__decorate([
    Prop({ type: Object, default: () => { } })
], QuestionHeader.prototype, "question", void 0);
tslib_1.__decorate([
    Prop({ type: Number })
], QuestionHeader.prototype, "index", void 0);
QuestionHeader = tslib_1.__decorate([
    Component({
        name: 'QuestionHeader',
        components: {
            LongContentContainer
        },
        filters: {
            transferType(type) {
                switch (type) {
                    case 0:
                        return "单选题";
                    case 1:
                        return "多选题";
                    case 2:
                        return "问答题";
                    case 3:
                        return "判断题";
                    case 4:
                        return "填空题";
                    case 5:
                        return "不定项选择题";
                    case 6:
                        return "材料题";
                    default:
                        return "未知的题型";
                }
            }
        }
    })
], QuestionHeader);
export default QuestionHeader;
